export default "__VITE_ASSET__BLojmRVt__"